module.exports = __webpack_public_path__ + "static/media/logo-final-rapid.84de5c8a.png";